import { Loader } from "./Loader";

export const FullScreenLoader = () => {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <Loader />
    </div>
  );
};
